import { getContactsQueryKey } from '../keys';
import { UseContactParams } from './types';

export const getContactQueryKey = (params: UseContactParams) => {
  return [...getContactsQueryKey(), 'contact', params] as const;
};

export type ContactQueryKey = ReturnType<typeof getContactQueryKey>;
